
import { Observable } from 'rxjs';
import { UserService } from '../../../_services/user.service';
import { AuthService } from '../../../../views/pages/auth/auth.service';
import { Router } from '@angular/router';
// import { AuthService } from '../../../_services/auth.service';
export function appInitializer(userService:UserService, authService: AuthService)
{
    console.log(window.location.href);
   const url: any = window.location.href;
    return ()=> new Promise(resolve =>{
        if (url.indexOf('zomato') != -1 ) {
            console.log('this is rezolved');
            return resolve(true);
        }
        const urlParams = new URLSearchParams(window.location.search);
        console.log('urlParams', urlParams);
        
        const accessToken = urlParams.get('access_token');
        const refreshToken = urlParams.get('refresh_token');
        if (accessToken && refreshToken) {
            localStorage.setItem('accessToken', accessToken);
            localStorage.setItem('refreshToken', refreshToken);
            authService.setTokens({ IdToken: accessToken, RefreshToken: refreshToken });
            
            authService.fetchUserContext(accessToken).subscribe(
                meData => {
                    const role = meData.role || (meData.roles && meData.roles[0]) || 'USER';
                    const userEmail = meData.email;
                    
                    const roles = meData.roles || (meData.role ? [meData.role] : []);
                    const lenderData = {
                        type: meData.tenant_type || "",
                        org: meData.tenant_id || "",
                        role: role,
                        roles: roles,
                        name: meData.name || userEmail.split("@")[0],
                        email: userEmail
                    };
                    
                    localStorage.setItem('email_id_raindow', userEmail);
                    localStorage.setItem('user', JSON.stringify(lenderData));
                    authService.user = {
                        email: userEmail,
                        userName: userEmail,
                        role: role,
                        roles: roles,
                        name: meData.name || userEmail.split("@")[0],
                        ...meData
                    };
                    
                    const permissions = authService.mapPermissionsToLegacy(meData.permissions_flat || []);
                    authService.permissions = permissions;
                    localStorage.setItem('permissions', JSON.stringify(permissions));
                    authService.setPermissions({ permissions });
                    authService.startTokenUpdateTimer(4);
                    
                    try {
                        const urlWithoutParams = window.location.origin + window.location.pathname;
                        window.history.replaceState({}, document.title, urlWithoutParams);
                    } catch (e) {}
                    
                    resolve(true);
                },
                error => {
                    console.error("appInitializer SSO error:", error);
                    localStorage.clear();
                    resolve('foo');
                }
            );
            return;
        }

        const code = urlParams.get('code');
        console.log('code', code)
        if (code && code != "") {
            resolve(true);
        }
    const refresh_token: string = localStorage.getItem('refreshToken');
    if (refresh_token && refresh_token != '' && refresh_token != 'undefined') {
        userService.getTokens(refresh_token).subscribe(response => {
            if (response && response.access) {
                const accessToken = response.access;
                const newRefreshToken = response.refresh || refresh_token;
                
                localStorage.setItem('accessToken', accessToken);
                localStorage.setItem('refreshToken', newRefreshToken);
                authService.setTokens({ IdToken: accessToken, RefreshToken: newRefreshToken });
                
                authService.fetchUserContext(accessToken).subscribe(
                    meData => {
                        const role = meData.role || (meData.roles && meData.roles[0]) || 'USER';
                        const userEmail = meData.email;
                        
                        const roles = meData.roles || (meData.role ? [meData.role] : []);
                        const lenderData = {
                            type: meData.tenant_type || "",
                            org: meData.tenant_id || "",
                            role: role,
                            roles: roles
                        };
                        
                        localStorage.setItem('email_id_raindow', userEmail);
                        localStorage.setItem('user', JSON.stringify(lenderData));
                        authService.user = {
                            email: userEmail,
                            userName: userEmail,
                            role: role,
                            roles: roles,
                            ...meData
                        };
                        
                        const permissions = authService.mapPermissionsToLegacy(meData.permissions_flat || []);
                        authService.permissions = permissions;
                        localStorage.setItem('permissions', JSON.stringify(permissions));
                        authService.setPermissions({ permissions });
                        authService.startTokenUpdateTimer(4);
                        resolve(true);
                    },
                    error => {
                        console.error("appInitializer fetchUserContext error:", error);
                        if (error && (error.status === 401 || error.status === 403)) {
                            localStorage.clear();
                        }
                        resolve('foo');
                    }
                );
            } else {
                localStorage.clear();
                resolve('foo');
            }
        }, error => {
            console.error("appInitializer token refresh error:", error);
            if (error && (error.status === 401 || error.status === 403)) {
                localStorage.clear();
            }
            resolve('foo');
        });
    }  else{
        setTimeout(() => {
            resolve('foo');
          }, 300);
    }
   });

    
}